import { computed, ref } from 'vue'

import { locationService } from '@/api/services/location'
import { useCookie } from '@/composables/useCookie'
import { DEFAULT_CENTER, type LngLat } from '@/composables/useLocation'
import { useRequest } from '@/composables/useRequest'
import { REGION_COOKIE } from '@/constants/storage'

/** У Ташкента в списке бэкенда id = 0 — он же дефолт. */
const DEFAULT_REGION_ID = 0

/**
 * Регионы бренда. Активный регион определяет витрину меню и центр карты,
 * пока клиент не выбрал точку.
 */
export function useRegions() {
  const regionCookie = useCookie(REGION_COOKIE, { default: String(DEFAULT_REGION_ID) })

  const request = useRequest(locationService.regions)

  const regions = computed(() => request.data.value ?? [])
  const loading = request.isLoading

  const currentRegionId = computed(() => Number(regionCookie.value) || DEFAULT_REGION_ID)
  const activeRegion = computed(() =>
    regions.value.find((region) => region.id === currentRegionId.value),
  )

  /** Центр региона приходит не из API — его ищет карта по названию. */
  const regionCenter = ref<LngLat>(DEFAULT_CENTER)

  function setRegionId(value: number): void {
    regionCookie.value = String(value)
  }

  function setRegionCenter(value: LngLat): void {
    regionCenter.value = value
  }

  async function getRegions(): Promise<void> {
    await request.execute()
  }

  return {
    regions,
    loading,
    activeRegion,
    currentRegionId,
    regionCenter,
    setRegionId,
    setRegionCenter,
    getRegions,
  }
}
